// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","256":"channel"}[chunkId] || chunkId) + "." + {"177":"6e894436","256":"8c11632d","556":"daeb3ee9"}[chunkId] + ".js";
};